import { DEFAULT_HOURS_INTERVAL } from '@constants/companies';
import { convertHoursBetweenZones } from '@helpers/dates';

export type HoursInterval = { from: string; to: string };

export type BusinessHoursDay = { day: number; hours: HoursInterval[] };

export type BusinessHours = { timeZone: string; days: BusinessHoursDay[] };

const WEEKDAYS = [1, 2, 3, 4, 5];

const isProvisionalZone = (zone: string) => zone === 'UTC' || zone.startsWith('Etc/');

export const hasEmptyRange = (hours: Partial<BusinessHours> | null | undefined) =>
    (hours?.days || []).some(day => day.hours.some(({ from, to }) => from === to));

export const weekdayBusinessHours = (timeZone: string): BusinessHours => ({
    timeZone,
    days: WEEKDAYS.map(day => ({ day, hours: [{ ...DEFAULT_HOURS_INTERVAL }] })),
});

export const toEditedBusinessHours = (
    stored: Partial<BusinessHours> | null | undefined,
    viewerZone: string,
    referenceDate = new Date(),
): BusinessHours => {
    const storedZone = stored?.timeZone || 'UTC';
    return {
        timeZone: isProvisionalZone(storedZone) ? viewerZone : storedZone,
        days: convertHoursBetweenZones(stored?.days || [], storedZone, viewerZone, referenceDate),
    };
};

export const toStoredBusinessHours = (
    edited: Partial<BusinessHours> | null | undefined,
    viewerZone: string,
    referenceDate = new Date(),
): BusinessHours => {
    const scheduleZone = edited?.timeZone || viewerZone;
    return {
        days: convertHoursBetweenZones(edited?.days || [], viewerZone, scheduleZone, referenceDate),
        timeZone: scheduleZone,
    };
};
